var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.isOpen,"fullscreen":""},on:{"update:visible":function($event){_vm.isOpen=$event}}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }